import SignUpPage from '@gameday/react-components/components/SignUpPage'
import { useEffect } from 'react'
import { signUpMsgSuccess } from 'shared/copy'

import routes from '../../../../constants/routes/routes'
import { buildPath } from '../../../../utils/common'

const SignUpGuest = ({
  signUpGuest,
  eventLogo,
  signUpGuestMsg,
  isSubmitPending,
  width,
  setSignupGuestMsg,
  recaptcha,
  resetForm,
  history,
  formType,
}) => {
  useEffect(() => {
    setSignupGuestMsg(undefined)
    resetForm(true)
  }, [])

  // biome-ignore lint/complexity/useOptionalChain: TODO
  const isExistingAccountError = signUpGuestMsg && signUpGuestMsg.includes('account already exists')
  const shouldUseAlertBox = isExistingAccountError

  return (
    // biome-ignore lint/complexity/noUselessFragments: TODO
    <>
      <SignUpPage
        title="Register as a guest"
        logo={eventLogo}
        loginLink={buildPath(formType, routes.login.path, history)}
        handleSubmit={(...args) => {
          setSignupGuestMsg({
            type: null,
            message: '',
          })
          recaptcha()
            .then(() => {
              signUpGuest(...args)
            })
            .catch(() => {
              setSignupGuestMsg({
                type: 'ReCAPTCHA',
                message: 'Abnormal action detected',
              })
            })
        }}
        signingUp={isSubmitPending}
        formSuccess={signUpGuestMsg === signUpMsgSuccess ? signUpGuestMsg : ''}
        formError={signUpGuestMsg && signUpGuestMsg !== signUpMsgSuccess ? signUpGuestMsg : ''}
        useAlertBox={shouldUseAlertBox}
        onChange={() =>
          setSignupGuestMsg({
            type: null,
            message: '',
          })
        }
        application={width !== 'xs' ? 'desktop' : 'mobile'}
        includePassword={false}
        buttonText="Continue as a guest"
      />
    </>
  )
}

SignUpGuest.defaultProps = {
  signUpGuestMsg: '',
}

export default SignUpGuest
